import React, { Component } from 'react';
import logo from '../../resources/Firefly_Logo_White_New.png';
import About from '../about/about.jsx';

export class Home extends Component {
    state = {
        show: true
    };
    showModal = e => {
        if (e === true) {
            this.setState({
                show: false
            })
        } else {
            this.setState({
                show: true
            });
        }
    };

    onClick = (e) => {
        this.showModal(this.state.show);
    }
    render() {
        return (
            <div>
                <section className="intro">
                    <div className="inner">
                        <div className="content">
                            <img className="home-logo" src={logo} alt="firefly pediatrics logo" />
                        </div>
                    </div>

                </section>
                {/* <h2>Announcements</h2>
                <section id="announcements">
                    <div className="full">
                        <p>New <a className="glow" href="https://firefly.pcc.com/portal">Patient Portal</a> Went Live January 31, 2022.</p>
                    </div>
                </section> */}
                <h1> {String.fromCharCode(160)} </h1>
                <div id="about">
                    <About />
                </div>

            </div>
        )
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/components/home/home.jsx